import { useEffect } from "react";

const SITE = "https://www.decodemydenial.com";
const OG_IMAGE = `${SITE}/og-image.jpg`;

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

export function injectJsonLd(id, data) {
  document.getElementById(id)?.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

export function removeJsonLd(id) {
  document.getElementById(id)?.remove();
}

export function useMeta(title, description, { noindex = false, ogType = "website", image } = {}) {
  const ogImage = image ? image.replace("https://decodemydenial.com", SITE) : OG_IMAGE;
  useEffect(() => {
    const path = window.location.pathname;
    const url = `${SITE}${path}`;
    const finalTitle = title || "Denial Decoder | Denied? Decode your denial in minutes.";
    const finalDesc = description || "Upload your denial letter — free verdict in minutes. Add your contract for the exact clause, the denial's true strength, and your appeal letter.";
    document.title = finalTitle;
    setMeta("name", "description", finalDesc);
    setCanonical(url);
    if (noindex) setMeta("name", "robots", "noindex");
    else document.head.querySelector('meta[name="robots"]')?.remove();
    setMeta("property", "og:title", finalTitle);
    setMeta("property", "og:description", finalDesc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", ogType);
    setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", finalTitle);
    setMeta("name", "twitter:description", finalDesc);
    setMeta("name", "twitter:image", ogImage);
  }, [title, description, noindex, ogType, ogImage]);
}

// For utility/auth pages that must never be indexed and otherwise don't set page meta.
export function useNoindex() {
  useEffect(() => {
    setMeta("name", "robots", "noindex");
    return () => document.head.querySelector('meta[name="robots"]')?.remove();
  }, []);
}
